import { render, staticRenderFns } from "./EditNormal.vue?vue&type=template&id=34987f78&scoped=true&"
import script from "./EditNormal.vue?vue&type=script&lang=js&"
export * from "./EditNormal.vue?vue&type=script&lang=js&"
import style0 from "./EditNormal.vue?vue&type=style&index=0&id=34987f78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34987f78",
  null
  
)

export default component.exports